/**
 * DOB picker age bounds for the referral forms. CYP referrals narrow by the
 * school phase: primary 4-11, secondary 11-16 (the picker adds a 1-year
 * buffer on the oldest end); unknown phase falls back to the full CYP range.
 */
export function dobAgeRange(ageBand, schoolType) {
  const isCyp = ageBand === 'cyp';
  if (isCyp && schoolType === 'primary') return { minAgeYears: 4, maxAgeYears: 11 };
  if (isCyp && schoolType === 'secondary') return { minAgeYears: 11, maxAgeYears: 16 };
  return isCyp ? { minAgeYears: 0, maxAgeYears: 17 } : { minAgeYears: 18, maxAgeYears: 120 };
}
